export default __webpack_public_path__ + "static/media/reebok_stimuli_fr_phone.d272614c.mp4";